export const locale = {
    lang: 'en',
    data: {
        'SAMPLE': {
            'HELLO': 'Hello, World!'
        }
    }
};



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/sample/i18n/en.ts